import { Link, useMatch } from 'react-router-dom';
import { AImage } from 'components/atoms';
import './TabbarItem.components.scss';
import { circle } from 'utils/assets';
import { useState } from 'react';

interface IProps {
  path: string;
  title: string;
  icon: string;
  isDisabled?: boolean;
  enableText?: boolean;
  hasSubmenu?: boolean;
  submenuItems?: Array<{ title: string; path: string }>;
  arrowIcon?: string;
}

export const TabbarItem = ({
  path,
  title,
  icon,
  isDisabled,
  enableText,
  hasSubmenu = false,
  submenuItems = [],
  arrowIcon,
}: IProps) => {
  const match = useMatch(path);
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);

  const toggleSubmenu = (e: React.MouseEvent) => {
    if (hasSubmenu) {
      e.preventDefault();
      setIsSubmenuOpen(!isSubmenuOpen);
    }
  };

  const isSubmenuItemActive = (item: { title: string; path: string }) => {
    return location.pathname === `/${path}/${item.path}`;
  };

  const hasActiveSubmenuItem = hasSubmenu && submenuItems.some((item) => isSubmenuItemActive(item));

  return (
    <div className='tabbar-item-wrapper'>
      <Link
        to={hasSubmenu ? `#` : `/${path}`}
        className={`tabbar-item ${match ? 'tabbar-item--active' : ''} ${
          isDisabled ? 'tabbar-item--inactive' : ''
        }`}
        onClick={hasSubmenu ? toggleSubmenu : undefined}
      >
        <div className={`tabbar-item__icon--container ${!enableText && 'm-0'}`}>
          <img src={circle} alt='circulo' className='tabbar-item__icon--circle' />
          <AImage
            url={icon}
            alt=''
            className={`tabbar-item__icon ${match && 'tabbar-item__icon--active'}`}
          />
        </div>
        {enableText && (
          <div className='tabbar-item__content'>
            <span className='tabbar-item__title'>{title}</span>
            {hasSubmenu && arrowIcon && (
              <div
                className={`tabbar-item__arrow ${isSubmenuOpen ? 'tabbar-item__arrow--open' : ''}`}
              >
                <AImage url={arrowIcon} alt='Expandir' />
              </div>
            )}
          </div>
        )}
      </Link>

      {hasSubmenu && isSubmenuOpen && (
        <div className={`tabbar-item__submenu ${hasActiveSubmenuItem ? 'tabbar-item__submenu--has-active' : ''}`}>
          {submenuItems.map((item, index) => (
            <Link 
              key={index} 
              to={`/${path}/${item.path}`} 
              className={`tabbar-item__submenu-item ${
                isSubmenuItemActive(item) ? 'tabbar-item__submenu-item--active' : ''
              }`}
            >
              <span>{item.title}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};